import PropTypes from 'prop-types';
import { memo } from 'react';
import TourSearchBar from './TourSearchBar';
import TourList from './TourList';

const TourInformation = ({ tripId }) => (
  <div className="mx-5 my-5">
    <TourSearchBar tripId={tripId} />
    <TourList tripId={tripId} />
  </div>
);

TourInformation.propTypes = {
  tripId: PropTypes.string.isRequired,
};

export default memo(TourInformation);
